<template>
    <component :is="controlComponent"
            @input="updateVal($event)"
            v-bind="fieldData"
            v-model="field.val">
    </component>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';


    export default {
        props: {
            field: {
                type: Object,
                required: true,
            },
            controlComponent: {
                type: String,
                required: true,
            },
            controlId: {
                type: String,
            },
            controlledBy: {
                type: String,
            },
            controlBehaviour: {
                type: Object,
            },
        },
        computed: {
            ...mapGetters(['form']),
            computedState() {
                const controllerValue = this.form.controllers[this.controlledBy];
                const state = Object.entries(this.controlBehaviour).map(([key, val]) => {
                    return {
                        [key]: (controllerValue === val),
                    };
                });

                return Object.assign({}, this.field.state, ...state);
            },
            fieldData() {
                if (this.controlId) {
                    return this.field;
                }

                const { state, ...rest } = this.field;

                return {
                    ...rest,
                    state: (this.controlledBy ? this.computedState : state),
                };
            },
        },
        methods: {
            ...mapActions(['setFormController']),
            updateVal() {
                if (!this.controlId) {
                    return;
                }

                this.setFormController({
                    id: this.controlId,
                    val: this.field.val,
                });
            },
        },
        watch: {
            field: {
                handler() {
                    this.updateVal();
                },
                immediate: true,
                deep: true,
            },
        },
        beforeDestroy() {
            if (!this.controlId) {
                return;
            }

            this.setFormController({
                id: this.controlId,
                val: '',
            });
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2d51f2f2